<template>
  <div class="container-fluid">
    <loading v-if="loadingRender"></loading>
    <panel Title="ثبت امضا" Des="لطفا یک رمز برای امضای دیجیتال خود وارد کنید" :IsBtnBack="false" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row my-3">
      <div class="col-12">
        <h5>مشخصات صاحب امضا:</h5>
      </div>
      <div class="col-12">
        <small>صاحب امضا: </small> <span class="text"> {{ IntroduceInfo.fa_first_name + ' ' + IntroduceInfo.fa_last_name }}</span> <small> کد ملی صاحب امضا: </small><span class="text"> {{ IntroduceInfo.national_code }} </span>
      </div>
      <div class="col-md-4 col-12 p-2"></div>
      <div id="CreateSign" class="col-md-4 col-12 p-2">
        <input type="password" v-model="pass" class="form-control text-center" dir="ltr" placeholder="رمز امضای دیجیتال" />
      </div>
      <div class="col-md-4 col-12 p-2"></div>
      <div class="col-md-4 col-12 p-2"></div>
      <div id="CreateSign" class="col-md-4 col-12 p-2">
        <input type="password" v-model="passrpt" class="form-control text-center" dir="ltr" placeholder="تکرار رمز امضای دیجیتال" />
      </div>
      <div class="col-md-4 col-12 p-2"></div>
      <div class="col-md-4 col-12 p-2"></div>
      <div class="col-md-4 col-12 p-2">
        <button @click="submitCreateSing" class="btn btn-success w-100">ثبت رمز</button>
      </div>
      <div class="col-md-4 col-12 p-2"></div>
    </div>
  </div>
</template>
<script>
import Panel from '../../Tools/NetPa/Panel.vue'
import Loading from '../../Tools/NetPa/Loading.vue'

export default {
  components: { Panel, Loading },
  props: ['IntroduceInfo'],
  data() {
    return {
      loadingRender: false,
      pass: '',
      passrpt: '',
      DataAxiosAdd: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
        },
        certificate_request_id: this.IntroduceInfo.request_id,
        national_code: this.IntroduceInfo.national_code,
        password: '',
      },
    }
  },
  methods: {
    submitCreateSing() {
      if (this.pass.length < 5) {
        this.$mySweetDefaultTost('هشدار', 'طول کلمه عبور نمیتواند کتر از 5 حرف باشد', 'error', 2500)
      } else if (!this.pass.match(/[A-Z]/)) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور باید شامل حروف بزرگ انگلیسی باشد', 'error', 2500)
      } else if (!this.pass.match(/[a-z]/)) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور باید شامل حروف کوچک انگلیسی باشد', 'error', 2500)
      } else if (!this.pass.match(/[0-9]/)) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور باید شامل اعداد باشد', 'error', 2500)
      } else if (this.pass != this.passrpt) {
        this.$mySweetDefaultTost('هشدار', 'کلمه عبور و تکرارش همخوانی ندارند', 'error', 2500)
      } else {
        this.loadingRender = true
        this.DataAxiosAdd.password = this.pass
        var DataAxios = { method: 'POST', action: 'ElectronicSafte/CreateSign', arryfildValue: this.DataAxiosAdd }
        this.$PostData_netpatoken(DataAxios)
          .then((result) => {
            if (result.status == 'success') {
              this.loadingRender = false
              this.$mySweetDefaultTost('ثبت موفق اطلاعات', 'امضای شما با موفقیت در سیستم ثبت شد', 'success', 2500)
              this.$emit('create_success', result.data)
            } else {
              this.loadingRender = false
              this.ErrorList = result.data
            }
          })
          .catch((error) => {
            this.loadingRender = false
            this.ErrorList = [{ message: 'مشکل ناشناخته دوباره تلاش کنید' }]
          })
      }
    },
  },
}
</script>
<style scoped>
small {
  font-size: 13px !important;
  font-weight: normal !important;
}
span.text {
  font-size: 12px !important;
  font-weight: bold !important;
}
</style>
